import * as types from './actionTypes.js';

export const setSharableProductImage = sharableProductImage => ({
    type: types.SHARABLE_PRODUCT_IMAGE_SETTED,
    sharableProductImage,
});



// WEBPACK FOOTER //
// ./src/actions/sharing.js